import React, { FC, useEffect, useState } from "react";
import "./KeywordExtractionTool.css";
import axios from "axios";
import { Helmet } from "react-helmet";
import { API_URL } from "../../constants/urls";

interface KeywordExtractionToolProps {}

const KeywordExtractionTool: FC<KeywordExtractionToolProps> = () => {
  const [message, setMessage] = useState<string>();
  const [result, setResult] = useState<string>();
  const [error, setError] = useState<boolean>();
  const [loading, setLoading] = useState<boolean>(false);
  const url = API_URL;
  function submitContact(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    setLoading(true);
    if (message === null) {
      setError(true);
      return;
    }
    setError(false);
    let mess = message?.replace(/(?:\r\n|\r|\n)/g, " ");
    mess = mess?.replace(/["']/g, "");
    mess = mess?.replace(/“/g, "");
    axios
      .post(url + `apis/nuhman/tech/keyword-extract`, {
        text: mess,
      })
      .then((res) => {
        //setCountries(res?.data);
        setResult(res?.data);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    const url = API_URL;
    axios
      .post(
        url + `apis/nuhman/tech/page-view?pageId=` + KeywordExtractionTool.name
      )
      .then((res) => {
        //setCountries(res?.data);
        //setTrendingContents(res?.data);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      <Helmet>
        <title>{"Nuhman.com - Keyword Tool"}</title>
        <meta
          name="description"
          content={"Find SEO keywords for a text tool"}
        />
        <meta
          property="og:title"
          content={"Nuhman.com - SEO Keyword Finder tool"}
        />
        <meta
          property="og:description"
          content={"Find SEO keywords for a text tool"}
        />
      </Helmet>
      <div className="container-fluid py-3">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="overlay position-relative bg-light rresult">
                <div className="mb-3 rresult col-lg-12">
                  <h3 className=" mg">{"SEO Keyword Finder Tool"}</h3>
                  <p>Paste your text and get comma delimited SEO keywords</p>

                  {loading && (
                    <>
                      <div className="text-center">
                        <div className="spinner-border" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    </>
                  )}

                  {!loading && (
                    <>
                      {" "}
                      <form
                        name="sentMessage"
                        id="contactForm"
                        onSubmit={submitContact}
                      >
                        <div className="control-group">
                          <textarea
                            className="form-control"
                            rows={4}
                            id="text"
                            name="text"
                            placeholder="Text"
                            onChange={(event) => setMessage(event.target.value)}
                            required
                            data-validation-required-message="Please enter your message"
                          ></textarea>
                          <p className="help-block text-danger"></p>
                        </div>
                        <div>
                          <button
                            className="btn btn-primary font-weight-semi-bold px-4"
                            style={{ height: 50 }}
                            type="submit"
                            id="sendMessageButton"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </>
                  )}

                  <div>
                    {result && (
                      <>
                        {" "}
                        <br />
                        <p>{result}</p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <p>**</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KeywordExtractionTool;
